import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import CoreButton from '@components/Buttons/CoreButton';
import Avatar from '@components/UI/Avatar/Avatar';
import AppDownloadMobileSection from '@components/UI/AppDownloadMobileSection';
import { useUserState } from '@context/UserContext';
import NotificationMenu from '@domain/Notification/NotificationMenu';
import useRouteChanged from '@hooks/useRouteChanged';
import useSetPageHeaderStyle from '@hooks/useSetPageHeaderStyle';
import loadable from '@loadable/component';
import { AppBar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Feature, useFeature } from 'flagged';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import MobileNavigationMenu from './Menus/MobileNavigationMenu';
const HamburgerMenu = loadable(() => import('@components/Icons/HamburgerMenu'));
const RepeatLogo = loadable(() => import('@components/Icons/Brand/RepeatLogo'));
const ChevronDown = loadable(() => import('@components/Icons/ChevronDown'));
const MobileHeader = styled(AppBar) `
  font-family: ${({ theme }) => theme.typography.fontFamily};
  display: flex;
  flex-direction: row;
  height: 72px;
  justify-content: space-between;
`;
const LogoContainer = styled(Link) `
  background: ${({ theme }) => theme.palette.primary.main};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 72px;
  flex-shrink: 0;
  padding: ${({ theme }) => theme.spacing(2)};

  & > svg {
    fill: white;
    width: 100%;
  }
`;
const JoinNowButtonContainer = styled('div') `
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(3)}`};
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[100]};
  border-top: 1px solid ${({ theme }) => theme.palette.grey[100]};

  & > button {
    width: 100%;
  }

  @media (max-width: 320px) {
    padding: ${({ theme }) => `${theme.spacing(2)}`};
  }
`;
const MobileMenuButton = styled(CoreButton) `
  width: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border: 1px solid ${({ theme }) => theme.palette.grey[100]}!important;
  border-right: none;

  & > svg {
    fill: ${({ theme }) => theme.palette.grey[400]};
    width: 20px;
  }
`;
const ProfileButtonContainer = styled('div') `
  width: 100%;
  display: flex;
  justify-content: flex-end;

  & > button {
    border-left: 1px solid ${({ theme }) => theme.palette.grey[100]};
    padding: 0 ${({ theme }) => theme.spacing(2)};
  }
`;
const ProfileLogo = styled('div') `
  width: 30px;
  height: 30px;
  border-radius: ${({ theme }) => theme.shape.borderRadius};
  border: 2px solid ${({ theme }) => theme.palette.grey[100]};
  margin-right: ${({ theme }) => theme.spacing(1)};

  & > img {
    width: 100%;
  }
`;
const ProfileChevron = styled(ChevronDown) `
  fill: ${({ theme }) => theme.palette.grey[200]};
  height: 8px;
`;
/**
 * New Mobile Navigation Header when the new header feature flag is on.
 * The mobile header should only be used for screen breakpoint below
 * 1280px within the AppBar
 */
const MobileNavigationHeader = ({ onShowLoginModal, onShowFundsModal, onShowCouponModal, }) => {
    var _a, _b, _c;
    const { authenticated, userProfile } = useUserState();
    const [showMenu, setShowMenu] = useState(false);
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const isMobilePromotionEnabled = !!useFeature('enable_mobile_app_promotion');
    const handleLogin = () => {
        onShowLoginModal();
    };
    const handleOpen = () => {
        setShowMenu(true);
    };
    const handleOpenProfileMenu = () => {
        setShowMenu(true);
        setShowProfileMenu(true);
    };
    const handleClose = () => {
        setShowMenu(false);
        setShowProfileMenu(false);
    };
    // Close the menu when a user clicks a link
    useRouteChanged(() => {
        handleClose();
    });
    useSetPageHeaderStyle(72);
    return (_jsxs(_Fragment, { children: [_jsxs(MobileHeader, { position: "fixed", color: "inherit", children: [_jsx(LogoContainer, { to: "/", children: _jsx(RepeatLogo, { className: "logo", title: "Repeat.GG" }) }), !authenticated && (_jsx(JoinNowButtonContainer, { children: _jsx(CoreButton, { type: "button", onClick: handleLogin, roundCorners: false, children: "Log In" }) })), authenticated && (_jsxs(ProfileButtonContainer, { children: [_jsx(Feature, { name: "enable_notifications", children: _jsx(NotificationMenu, {}) }), _jsxs(CoreButton, { type: "button", appearance: "text", roundCorners: false, onClick: handleOpenProfileMenu, ariaLabel: "Profile Menu", children: [_jsx(ProfileLogo, { children: _jsx(Avatar, { handle: (_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.handle) !== null && _a !== void 0 ? _a : '', borderUrl: (_b = userProfile === null || userProfile === void 0 ? void 0 : userProfile.borderUrl) !== null && _b !== void 0 ? _b : '', avatarUrl: (_c = userProfile === null || userProfile === void 0 ? void 0 : userProfile.profileTinyUrl) !== null && _c !== void 0 ? _c : '' }) }), _jsx(ProfileChevron, {})] })] })), _jsx(MobileMenuButton, { type: "button", appearance: "text", roundCorners: false, onClick: handleOpen, children: _jsx(HamburgerMenu, { title: "Open menu" }) }), _jsx(MobileNavigationMenu, { onShowFundsModal: onShowFundsModal, onShowCouponModal: onShowCouponModal, loginAction: onShowLoginModal, open: showMenu, openProfileMenu: showProfileMenu, onClose: handleClose })] }), isMobilePromotionEnabled ? _jsx(AppDownloadMobileSection, {}) : null] }));
};
export default MobileNavigationHeader;
